import * as Sentry from '@sentry/react';

import { getSentryConfig, getVersion } from '~/config';

export function initSentry() {
  const sentryConfig = getSentryConfig();

  if (!sentryConfig.dsn) {
    console.warn('Sentry DSN not configured. Error tracking disabled.');
    return;
  }

  const { dsn, environment, tracesSampleRate } = sentryConfig;

  Sentry.init({
    dsn,
    environment,
    release: getVersion(),
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enabled: environment !== 'development',
    tracePropagationTargets: ['localhost', /^https:\/\/.*\.vercel\.app/],
  });
}
